import { Box, Typography, Button, Card, CardContent } from '@mui/material';
import { Error as ErrorIcon, Home as HomeIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

export function NotFoundPage() {
    const navigate = useNavigate();

    return (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
            <Card sx={{ maxWidth: 500, textAlign: 'center' }}>
                <CardContent sx={{ p: 4 }}>
                    <ErrorIcon sx={{ fontSize: 64, color: 'error.main', mb: 2 }} />
                    <Typography variant="h3" gutterBottom>
                        Page Not Found
                    </Typography>
                    <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
                        The page you're looking for doesn't exist or has been moved.
                    </Typography>
                    <Button variant="contained" startIcon={<HomeIcon />} onClick={() => navigate('/')} size="large">
                        Go to Dashboard
                    </Button>
                </CardContent>
            </Card>
        </Box>
    );
}
